import { atomWithReset } from 'jotai/utils'

import { type BrandGroup } from '~/hooks/useSurveyForSettingsQuery'

type DialogInfo =
  | {
      dialogType: 'create'
      brandGroup?: undefined
    }
  | {
      dialogType: 'delete' | 'update'
      brandGroup: BrandGroup
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
